import PropTypes from 'prop-types'

import { SimpleAlert, DefaultTooltip } from 'twyne-new.ui'

import TextTruncated from '@Components/TextTruncated'

const propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
}

export default function AlertLabel({ label, value }) {
  return <SimpleAlert className='text-center'>
    <DefaultTooltip content='Label' triggerProps={{ asChild: true }}>
      <div className='font-bold rounded-sm twy-border-accent border'>
        <TextTruncated maxLength="20">
          {label}
        </TextTruncated>
      </div>
    </DefaultTooltip>
    <DefaultTooltip content='Value' triggerProps={{ asChild: true }} side='bottom'>
      <div className='italic twy-text-base rounded-sm twy-border-base-accent border mt-1'>
        <TextTruncated maxLength="20">
          {value}
        </TextTruncated>
      </div>
    </DefaultTooltip>
  </SimpleAlert>
}

AlertLabel.propTypes = propTypes
AlertLabel.defaultProps = {}
